/* eslint-disable */
import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit {
    constructor(private host: ElementRef) {}

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.host.nativeElement.focus();
        }, 0);
    }
}
